<template>
  <div id="page-advertiser-campaign-list">
    <vx-title-bar :route="$route" :isRTL="$vs.rtl" />
    <div class="vx-card p-6">
      <div class="flex flex-wrap items-center">
        <dx-data-grid
          class="dx-card wide-card"
          :data-source="customDataSource"
          :focused-row-index="0"
          :show-borders="false"
          :focused-row-enabled="true"
          :column-auto-width="true"
          :column-hiding-enabled="true"
          :allow-column-reordering="true"
          :allow-column-resizing="true"
          @row-click="gotoDetails"
          :ref="gridRefKey"
        >
          >
          <dx-state-storing
            :enabled="true"
            type="custom"
            :custom-load="loadState"
            :custom-save="saveState"
            :storage-key="storageKey"
          />
          <dx-paging :page-size="20" />
          <dx-pager :show-page-size-selector="false" :show-info="true" />
          <dx-filter-row :visible="true" />

          <dx-column
            data-field="id"
            caption="Id"
            data-type="number"
            :width="90"
            :hiding-priority="2"
          />

          <dx-column
            data-field="name"
            :caption="$t('Campaign.Name')"
            :width="400"
            :hiding-priority="99"
          />
          <dx-column
            data-field="startDate"
            :caption="$t('Campaign.StartDate')"
            data-type="date"
            :width="190"
            :hiding-priority="1"
          />
          <dx-column
            data-field="endDate"
            :caption="$t('Campaign.EndDate')"
            data-type="date"
            :width="190"
            :hiding-priority="2"
          />
          <dx-column
            data-field="isActive"
            :caption="$t('Campaign.IsActive')"
            :width="190"
            :hiding-priority="7"
            data-type="boolean"
          />
          <dx-column
            data-field="isPremium"
            :caption="$t('Campaign.IsPremium')"
            :width="190"
            :hiding-priority="6"
          />
          <dx-column
            data-field="idStrategyType"
            :caption="this.$t('Campaign.StrategyType')"
            :hiding-priority="7"
          >
            <dx-lookup
              display-expr="description"
              value-expr="id"
              :data-source="strategyTypes"
            />
          </dx-column>
          <DxColumnChooser :enabled="true" />
          <DxToolbar>
            <DxItem name="addRowButton" />
            <DxItem
              name="columnChooserButton"
              locate-in-menu="auto"
              location="after"
            />
          </DxToolbar>
        </dx-data-grid>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moduleCampaignManagement from '@/store/campaign-management/moduleCampaignManagement.js'
import CustomStore from 'devextreme/data/custom_store'
import { notifyMixin } from '@/mixins/notifyMixin'
import DxDataGrid, {
  DxColumn,
  DxFilterRow,
  DxLookup,
  DxPager,
  DxPaging,
  DxStateStoring,
  DxToolbar,
  DxItem,
  DxColumnChooser
} from 'devextreme-vue/data-grid'

const gridRefKey = "grid-campaigns"
let _this = {}
export default {
  components: {
    DxDataGrid,
    DxColumn,
    DxFilterRow,
    DxLookup,
    DxPager,
    DxPaging,
    DxStateStoring,
    DxToolbar,
    DxItem,
    DxColumnChooser
  },
  mixins: [notifyMixin],
  data () {
    const customDataSource = new CustomStore({
      key: 'id',
      load: () => {
        return this.$store.dispatch('campaignManagement/fetchCampaigns', _this.activeOrganisation.id)
          .then((res) => {
            return res.data.items
          })
          .catch((error) => {
            this.notifyError(error)
          })
      }
    })

    return {
      customDataSource,
      gridRefKey,
      storageKey: 'dx_datagrid_gridCampaign_4',
      restoreFullGridState: false
    }
  },
  watch: {
    activeOrganisation: function (val) {
      console.log(`activeOrganisation changed to ${val.id}`)
      this.refreshGrid()
    },

  },
  computed: {
    ...mapGetters(["activeOrganisation"]),
    strategyTypes () {
      return this.$store.state.refCodes.strategyTypes.map(a => {
        return { ...a, description: this.$t(`StrategyTypeList.${a.description}`) }
      })
    },
  },
  methods: {
    gotoDetails (e) {
      if (e.rowType === 'data') {
        const grid = this.$refs[gridRefKey].instance
        grid.selectRows([e.key], false)
        localStorage[this.storageKey] = JSON.stringify(grid.state())
        this.$router.push(`/campaign/view/${e.key}`).catch(() => { })
      }
    },
    add () {
      this.$router.push("/campaign/new")
    },
    refreshGrid () {
      console.log(`refreshing grid ${this.$refs[gridRefKey]}`)
      const grid = this.$refs[gridRefKey].instance
      grid.refresh()
    },
    loadState () {
      const storage = localStorage[this.storageKey]
      if (storage) {
        const state = JSON.parse(storage)

        if (this.restoreFullGridState) {
          return state
        } else {
          const res = {
            columns: state.columns,
            pageSize: state.pageSize
          }
          for (let i = 0; i < res.columns.length; i++) {
            delete res.columns[i].filterValue
          }
          return res
        }
      }
    },
    saveState (state) {
      localStorage[this.storageKey] = JSON.stringify(state)
    }
  },
  mounted () {
  },
  created () {
    _this = this
    this.restoreFullGridState = this.$route.query.initial !== "true"
    if (!moduleCampaignManagement.isRegistered) {
      this.$store.registerModule(
        'campaignManagement',
        moduleCampaignManagement
      )
      moduleCampaignManagement.isRegistered = true
    }

  }
}
</script>

